import React, { type MouseEventHandler } from 'react'
import {
  Button,
  Conditional,
  kuiperClassNames,
  renderIcon,
} from '@opallabs/kuiper'
import { StrongText, DotLoader } from '@opallabs/lapidary'
import './styles.scss'

const message =
  'Something went wrong when we tried to capture the URL you entered. ' +
  'This may be because the website was too long ' +
  'or if there was an error with the connection. Please try again.'

type PreviewPaneProps = {
  error?: boolean
  layout?: string
  loading?: boolean
  onRefresh?: MouseEventHandler
}

const PreviewPane: React.FC<PreviewPaneProps> = ({
  error = false,
  layout,
  loading = false,
  onRefresh,
}) => (
  <div
    className={
      layout == 'desktop'
        ? kuiperClassNames('url-preview-pane')
        : kuiperClassNames('url-preview-pane-mobile')
    }
  >
    <Conditional condition={loading}>
      <React.Fragment>
        <div className={kuiperClassNames('loading-box')}>
          <DotLoader height={600} />
        </div>
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            position: 'fixed',
            top: 370,
            width: '100%',
          }}
        >
          <StrongText styleOverrides={{ fontSize: 14 }}>
            Building preview. This can take up to a minute.
          </StrongText>
        </div>
      </React.Fragment>
    </Conditional>
    <Conditional condition={error}>
      <div className={kuiperClassNames('preview-pane-error')}>
        {renderIcon('alert', {
          style: { height: 60, width: 63 },
          ariaMode: 'hidden',
        })}
        <h1>Uh oh!</h1>
        <p>{message}</p>
        <Button
          icon="refresh"
          label="Refresh"
          onClick={onRefresh}
          position="right"
          type="secondary"
        />
      </div>
    </Conditional>
  </div>
)

export default PreviewPane
